import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import {
  dateFormatter, getLegalEntityName, infoFormatterIntl, localeFormatter, timeFormatter, userFIOFormatter,
} from '../../../utils/formatters';
import { getViolationData } from '../../Violations/reducer';
import { loadControlWorkViolationById } from '../../Violations/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import Grid from '../../../components/base/Grid/Grid';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ViolationControlWorkDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentViolationControlWork: current = {},
    loadingCurrentViolationControlWork,
  } = useSelector(getViolationData);

  useEffect(() => {
    dispatch(loadControlWorkViolationById(id)).catch(responseLogWithNotification);
  }, []);

  const columns = [
    {
      dataField: 'started_at',
      text: 'Начало',
      disableSort: true,
      formatter: timeFormatter,
    },
    {
      dataField: 'ended_at',
      text: 'Конец',
      disableSort: true,
      formatter: timeFormatter,
    },
    {
      dataField: 'type',
      text: 'Описание',
      disableSort: true,
      formatter: item => localeFormatter('driver_work_period', item),
    },
  ];

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <TimerLoader loading={loadingCurrentViolationControlWork} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.violations.details' })}{` от ${dateFormatter(current?.created_at)}`}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.VIOLATION_CONTROL_WORK_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-1">
          {infoFormatterIntl('violation.violation_date', dateFormatter(current?.violation_date), {}, 'violation.violation_date')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('driver_name', userFIOFormatter({
            first_name: current?.driver?.driver_first_name,
            middle_name: current?.driver?.driver_middle_name,
            last_name: current?.driver?.driver_last_name,
          }, {}, 'driver_name'))}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('driver_license_number', current?.driver?.driver_license_number, {}, 'driver_license_number')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('carrier.name', getLegalEntityName(current?.applicant), {}, 'carrier.name')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('violation.vehicle_reg_number', current?.vehicle?.vehicle_lpn, {}, 'violation.vehicle_reg_number')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('violation.type', localeFormatter('work_rest_violation_type', current?.type), {}, 'violation.type')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('violation.violation', current?.description, {}, 'violation.violation')}
        </Row>
        <div className="f4 mt-2">Дневные интервалы</div>
        <Grid data={current?.work_periods || []} loading={loadingCurrentViolationControlWork} columns={columns} name="violation-datails-list" />
      </div>
    </div>
  );
}
